type Profile = { trade_categories: string[] | null; postcode: string | null };

/** Local URLs only, including protection against URL-parser slash normalisation. */
export function safeRedirect(value: unknown, fallback: string): string {
  if (typeof value !== "string" || !value.startsWith("/") || value.startsWith("//") || /[\\\u0000-\u0020\u007f]/.test(value)) return fallback;
  try {
    const url = new URL(value, "https://tradesfolk.co");
    if (url.origin !== "https://tradesfolk.co") return fallback;
    return `${url.pathname}${url.search}${url.hash}`;
  } catch {
    return fallback;
  }
}

function within(path: string, root: string) {
  return path === root || path.startsWith(`${root}/`);
}

export function roleDestination(role: "homeowner" | "tradesperson", next: unknown, fallback: string) {
  const destination = safeRedirect(next, fallback);
  const path = new URL(destination, "https://tradesfolk.co").pathname;
  const authPage = ["/login", "/signup", "/auth", "/account/setup"].some((root) => within(path, root));
  const wrongRole = (role === "homeowner" ? ["/dashboard", "/onboarding"] : ["/homeowner", "/post-job"]).some((root) => within(path, root));
  return authPage || wrongRole ? fallback : destination;
}

export function homeownerSignupDestination(next: unknown) {
  return roleDestination("homeowner", next, "/post-job");
}

export function signedInDestination(profile: Profile | null, homeowner: unknown, next: unknown) {
  if (profile) {
    if (!profile.trade_categories?.length || !profile.postcode) return "/onboarding";
    return roleDestination("tradesperson", next, "/dashboard");
  }
  if (homeowner) return roleDestination("homeowner", next, "/homeowner/dashboard");
  const destination = safeRedirect(next, "");
  return destination ? `/account/setup?next=${encodeURIComponent(destination)}` : "/account/setup";
}

export function signupNext(params: { get(name: string): string | null }) {
  return params.get("redirectTo") || params.get("redirect") || params.get("next");
}

export function withNext(path: string, next: unknown) {
  const destination = safeRedirect(next, "");
  if (!destination) return path;
  return `${path}${path.includes("?") ? "&" : "?"}next=${encodeURIComponent(destination)}`;
}
